<template>
  <div class="phone-numbers-card card">
    <div class="phone-header">
      <div class="header-left">
        <i class="bx bx-phone"></i>
        <span class="header-title">Клієнти Beta</span>
      </div>
      <div class="header-right">
        <span class="phone-count">{{ phonesList.length }}</span>
        <button
          class="add-phone-btn"
          @click="showAddModal = true"
          title="Додати номер"
        >
          <i class="bx bx-plus"></i>
        </button>
      </div>
    </div>

    <div class="phone-list">
      <div
        v-for="(phone, index) in phonesList"
        :key="index"
        :class="['phone-item', { 'menu-active': activeMenuIndex === index }]"
        @click.self="handlePhoneClick(phone)"
      >
        <div class="phone-icon bg-soft-info" @click="handlePhoneClick(phone)">
          <!-- <i class="bx bx-phone-call"></i> -->
          <span class="">{{ index + 1 }}</span>
        </div>

        <div class="phone-content" @click="handlePhoneClick(phone)">
          <div class="phone-number">+{{ formatPhoneNumber(phone.number) }}</div>
          <div class="phone-company">
            <i class="bx bx-buildings"></i>
            {{ phone.companyName || "Компанія не додана" }}
          </div>
        </div>

        <div
          class="phone-stats"
          v-if="phone.appealsStat && phone.appealsStat.count"
        >
          <div class="stats-info">
            <div class="stats-badge">
              <i class="bx bx-message-dots"></i>
              <span>{{ phone.appealsStat.count }}</span>
            </div>
            <div class="stats-date">
              {{ formatDateTime(phone.appealsStat) }}
            </div>
          </div>
        </div>

        <div class="phone-actions">
          <div class="action-menu-wrapper">
            <button
              class="action-btn action-btn-menu"
              @click.stop="toggleMenu(index)"
              title="Опції"
            >
              <i class="bx bx-dots-vertical-rounded"></i>
            </button>
            <div v-if="activeMenuIndex === index" class="action-dropdown">
              <div
                class="action-dropdown-item"
                @click.stop="
                  requestPhone = phone.number;
                  modalReqShow = true;
                "
              >
                <i class="bx bx-plus-circle"></i>
                <span>Створити заявку</span>
              </div>
              <div class="action-dropdown-divider"></div>
              <div
                class="action-dropdown-item"
                @click.stop="copyPhoneNumber(phone.number)"
              >
                <i class="bx bx-copy"></i>
                <span>Копіювати номер телефону</span>
              </div>
              <div
                class="action-dropdown-item"
                @click.stop="copyCompanyId(phone.companyId)"
              >
                <i class="bx bx-id-card"></i>
                <span>Копіювати ID компанії</span>
              </div>
              <div class="action-dropdown-divider"></div>
              <div
                class="action-dropdown-item"
                @click.stop="
                  clientPhone = phone.number;
                  showAdd_appeal.show = true;
                "
              >
                <i class="bx bx-revision"></i>
                <span>Повторне звернення</span>
              </div>
              <div
                class="action-dropdown-item"
                @click.stop="getAppealsByClient(phone.number)"
              >
                <i class="bx bx-show"></i>
                <span>Перегляд звернень</span>
              </div>
              <div class="action-dropdown-divider"></div>
              <div
                class="action-dropdown-item action-dropdown-item-danger"
                @click.stop="handleDelete(phone, index)"
              >
                <i class="bx bx-trash"></i>
                <span>Видалити</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="phonesList.length === 0" class="empty-state">
        <i class="bx bx-phone-off"></i>
        <p>No phone numbers</p>
      </div>
    </div>

    <!-- Модальне вікно для додавання номера -->
    <teleport to="body" v-if="showAddModal">
      <div class="modal-overlay" @click.self="closeAddModal">
        <div class="modal-container">
          <div class="modal-header">
            <div class="modal-header-content">
              <i class="bx bx-plus-circle"></i>
              <h3>Додати новий номер</h3>
            </div>
            <button class="modal-close" @click="closeAddModal">
              <i class="bx bx-x"></i>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label>Номер телефону</label>
              <div class="phone-input-wrapper-with-tag">
                <button
                  v-if="userPhone"
                  class="my-phone-tag"
                  @click="useMyPhone"
                  title="Підставити мій номер"
                >
                  <i class="bx bx-user"></i>
                  Мій номер
                </button>
                <div class="phone-input-wrapper">
                  <input
                    v-model="newPhone.number"
                    type="text"
                    class="form-input"
                    placeholder="+380631112233"
                    @keyup.enter="handleSearchByEnter"
                  />
                  <button
                    class="search-company-btn"
                    @click="findCompanies(newPhone.number)"
                    :disabled="!canSearch"
                    :title="
                      canSearch
                        ? 'Знайти компанії'
                        : 'Введіть мінімум 8 цифр для пошуку'
                    "
                  >
                    <i
                      :class="
                        isSearching
                          ? 'bx bx-loader-alt bx-spin'
                          : 'bx bx-search'
                      "
                    ></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>
                Виберіть компанію
                <span v-if="foundCompanies.length > 0" class="companies-count">
                  (знайдено: {{ filteredCompanies.length }} з
                  {{ foundCompanies.length }})
                </span>
              </label>

              <!-- Поле пошуку по компаніях -->
              <div
                v-if="foundCompanies.length > 0 && !isSearching"
                class="company-search-input-wrapper"
              >
                <i class="bx bx-search"></i>
                <input
                  v-model="companySearchQuery"
                  type="text"
                  class="company-search-input"
                  placeholder="Пошук по назві компанії..."
                />
                <button
                  v-if="companySearchQuery"
                  class="clear-search-btn"
                  @click="companySearchQuery = ''"
                  title="Очистити пошук"
                >
                  <i class="bx bx-x"></i>
                </button>
              </div>

              <div v-if="isSearching" class="company-search-loading">
                <div
                  class="spinner-border spinner-border-sm text-primary"
                  role="status"
                ></div>
                <span>Пошук компаній...</span>
              </div>
              <div v-else-if="foundCompanies.length > 0">
                <div
                  v-if="filteredCompanies.length === 0"
                  class="company-not-found"
                >
                  <i class="bx bx-search-alt"></i>
                  <p>
                    Не знайдено компаній за запитом "{{ companySearchQuery }}"
                  </p>
                  <button
                    class="btn btn-clear-filter"
                    @click="companySearchQuery = ''"
                  >
                    <i class="bx bx-x"></i>
                    Очистити фільтр
                  </button>
                </div>
                <div v-else class="company-list">
                  <div
                    v-for="company in filteredCompanies"
                    :key="company.companyId"
                    :class="[
                      'company-item',
                      { selected: newPhone.companyId === company.companyId },
                      { blocked: company.blocked },
                    ]"
                    @click="selectFoundCompany(company)"
                  >
                    <!-- Інформація про компанію -->
                    <div class="company-info">
                      <div class="company-header">
                        <div class="company-name">
                          {{ company.companyName }}
                          <i
                            v-if="company.personAdmin"
                            class="bx bxs-crown company-admin-badge"
                            title="Ви адміністратор цієї компанії"
                          ></i>
                          <span
                            v-if="company.blocked"
                            class="company-blocked-badge"
                            title="Компанія заблокована"
                          >
                            <i class="bx bx-lock"></i>
                            Заблокована
                          </span>
                        </div>
                        <div class="company-code">
                          ID: {{ company.companyId }}
                        </div>
                      </div>
                      <div
                        v-if="company.companyDescription"
                        class="company-description"
                      >
                        {{ company.companyDescription }}
                      </div>
                      <div v-if="company.more" class="company-meta">
                        <span
                          :class="[
                            'company-version-badge',
                            getVersionClass(company.more.companyServer),
                          ]"
                        >
                          <i
                            :class="getVersionIcon(company.more.companyServer)"
                          ></i>
                          {{ getVersionLabel(company.more.companyServer) }}
                        </span>
                        <span class="company-server-badge">
                          <i class="bx bx-server"></i>
                          {{
                            company.more.serverName ||
                            company.more.companyServer
                          }}
                        </span>
                        <span
                          v-if="company.more.dateOfCreate"
                          class="company-date"
                        >
                          <i class="bx bx-calendar"></i>
                          {{ formatDate(company.more.dateOfCreate) }}
                        </span>
                      </div>
                    </div>

                    <!-- Індикатор вибору -->
                    <i
                      v-if="newPhone.companyId === company.companyId"
                      class="bx bx-check-circle company-selected-icon"
                    ></i>
                  </div>
                </div>
              </div>
              <div
                v-else-if="searchPerformed && foundCompanies.length === 0"
                class="company-not-found"
              >
                <i class="bx bx-info-circle"></i>
                <p>Компанії не знайдено для цього номера</p>
                <button
                  class="btn btn-add-without-company"
                  @click="addPhoneWithoutCompany"
                >
                  <i class="bx bx-plus"></i>
                  Додати номер
                </button>
              </div>
              <div v-else class="company-hint">
                <i class="bx bx-info-circle"></i>
                <p>Введіть номер телефону для пошуку компаній</p>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-cancel" @click="closeAddModal">
              Скасувати
            </button>
            <button
              class="btn btn-primary"
              @click="handleAddPhone"
              :disabled="!isFormValid"
            >
              Додати
            </button>
          </div>
        </div>
      </div>
    </teleport>
  </div>

  <!-- Модальне вікно додати звернення по клієнту -->
  <add_appeal
    v-if="showAdd_appeal.show"
    @close="showAdd_appeal.show = false"
    :objCard="this.obj"
    :clientPhone="clientPhone"
  />

  <!-- Модальне вікно перегляду всіх звернень по клієнту -->
  <review_appeals
    v-if="showReview_appeal.show"
    @close="showReview_appeal.show = false"
    :objCard="appealsClient"
    :objTicket="this.obj"
    :clientPhone="clientPhone"
  />

  <createapplicBox
    v-if="modalReqShow"
    @close="modalReqShow = false"
    :phone="requestPhone"
  ></createapplicBox>
</template>

<script>
import add_appeal from "../formleft/activity/clients/add_appeal.vue";
import review_appeals from "../formleft/activity/clients/review_appeals.vue";
import createapplicBox from "@/views/application/createapplic.vue";
import { SuperAdmin, Tickets, ticketAppeals } from "@/API.js";
import {
  sendTelegramMessage,
  sendTelegramAddClientMessage,
} from "@/usabilityScripts/logsTelegram.js"; // надсилання логу в телеграм
import { storeS } from "@/store.js";

let apiAdmin = new SuperAdmin();
let apiTickets = new Tickets();
let apiAppeals = new ticketAppeals();

export default {
  props: {
    obj: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    add_appeal,
    review_appeals,
    createapplicBox,
  },
  data() {
    return {
      showAdd_appeal: {
        data: "",
        show: false,
      },
      showReview_appeal: {
        data: "",
        show: false,
      },
      clientPhone: "",
      appealsClient: {},
      activeMenuIndex: null,
      showAddModal: false,
      newPhone: {
        number: "",
        companyId: null,
        companyName: "",
      },
      foundCompanies: [],
      isSearching: false,
      searchPerformed: false,
      inputCount: 0,
      companySearchQuery: "",
      modalReqShow: false,
      requestPhone: "",
    };
  },
  computed: {
    phonesList() {
      const userPhones = this.obj?.userPhones;

      // Якщо userPhones - це string, розпарсуємо його
      if (typeof userPhones === 'string') {
        try {
          return JSON.parse(userPhones);
        } catch (e) {
          console.error('Помилка при розпарсуванні userPhones:', e);
          return [];
        }
      }

      // Якщо це вже масив, повертаємо як є
      if (Array.isArray(userPhones)) {
        return userPhones;
      }

      return [];
    },
    ticketId() {
      return this.obj?.ticketId;
    },
    isFormValid() {
      // Форма валідна якщо є номер та компанія, або якщо пошук виконано і компаній не знайдено
      return this.newPhone.number && this.newPhone.companyId;
    },
    canSearch() {
      const digitsOnly = this.newPhone.number.replace(/\D/g, "");
      return digitsOnly.length >= 8;
    },
    filteredCompanies() {
      if (!this.companySearchQuery || this.companySearchQuery.trim() === "") {
        return this.foundCompanies;
      }

      const query = this.companySearchQuery.toLowerCase().trim();

      return this.foundCompanies.filter((company) => {
        const companyName = (company.companyName || "").toLowerCase();
        const companyId = String(company.companyId || "").toLowerCase();
        const companyDescription = (
          company.companyDescription || ""
        ).toLowerCase();
        const serverName = (company.more?.serverName || "").toLowerCase();

        return (
          companyName.includes(query) ||
          companyId.includes(query) ||
          companyDescription.includes(query) ||
          serverName.includes(query)
        );
      });
    },
    userPhone() {
      return storeS.userbase.phone || null;
    },
    user() {
      /*
          Повертає дані за користувача з глобального стору.
      */
      return storeS.userbase;
    },
  },
  mounted() {
    // Close menu when clicking outside
    document.addEventListener("click", this.handleClickOutside);
    this.eventBus.off("openAppeals");
    this.eventBus.on("openAppeals", (status) => {
      console.log("sd", status);
      this.getAppealsByClient(status.phone);
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handlePhoneClick(e) {
      if (e.companyId && e.companyId != "none") {
        // якщо е об'єкт і є айді компанії, але його можна знайти
        this.$emit("openclient", e.companyId.replaceAll("-", ""));
      } else if (e.companyId == "none" || !e.companyId) {
        // якщо е об'єкт і є айді компанії, але його не можна знайти
        this.$emit("openclient", e.number);
      } else {
        // якщо е не об'єкт, то просто передаємо номер
        this.$emit("openclient", e);
      }
    },

    hasAppeals(phone) {
      return (
        phone.appealsStat &&
        phone.appealsStat.count &&
        phone.appealsStat.count > 0
      );
    },

    formatPhoneNumber(number) {
      const numStr = String(number);
      if (numStr.length >= 12) {
        return `${numStr.slice(0, 3)} ${numStr.slice(3, 5)} ${numStr.slice(
          5,
          8
        )} ${numStr.slice(8, 10)} ${numStr.slice(10)}`;
      }
      return numStr;
    },

    formatDateTime(appealsStat) {
      if (!appealsStat || !appealsStat.date) return "-";

      const date = appealsStat.date;
      const time = appealsStat.time || "";

      const [year, month, day] = date.split("-");
      const formattedDate = `${day}.${month}.${year}`;

      if (time) {
        const [hours, minutes] = time.split(":");
        return `${formattedDate} ${hours}:${minutes}`;
      }

      return formattedDate;
    },

    copyPhoneNumber(number) {
      const formattedNumber = `+${number}`;
      navigator.clipboard.writeText(formattedNumber).then(() => {
        console.log("Phone number copied:", formattedNumber);
        this.$toast.success(
          this.$t("Номер телефону скопійовано") + " - " + formattedNumber
        );
      });
      this.closeMenu();
    },

    copyCompanyId(companyId) {
      navigator.clipboard.writeText(String(companyId)).then(() => {
        console.log("Company ID copied:", companyId);
        this.$toast.success(
          this.$t("Ідентифікатор компанії скопійовано") + " - " + companyId
        );
      });
      this.closeMenu();
    },

    toggleMenu(index) {
      this.activeMenuIndex = this.activeMenuIndex === index ? null : index;
    },

    handleClickOutside(event) {
      // Закриваємо меню тільки при кліці (не при наведенні)
      // Перевіряємо, чи клік був поза меню та кнопкою
      if (event.type !== "click") return;

      const dropdown = document.querySelector(".action-dropdown");
      const menuButton = event.target.closest(".action-btn-menu");
      const isClickInsideDropdown = dropdown && dropdown.contains(event.target);

      if (!menuButton && !isClickInsideDropdown) {
        this.activeMenuIndex = null;
      }
    },

    closeMenu() {
      this.activeMenuIndex = null;
    },

    handleRepeatAppeal(phone) {
      this.closeMenu();
      this.$emit("repeat-appeal", phone);
    },

    handleViewAppeals(phone) {
      this.closeMenu();
      this.$emit("view-appeals", phone);
    },

    handleDelete(phone, index) {
      this.closeMenu();
      console.log("handleDelete > ", phone);
      console.log("handleDelete index >", index);
      this.phonesList.splice(index, 1);
      // Виводимо оновлений список для перевірки
      console.log("userPhone", this.phonesList);

      var list = this.phonesList;
      let obj = {
        userPhones: list,
      };

      apiTickets.savePhonesByTicket(this.ticketId, obj).then((result) => {
        if (result.status == "done") {
          this.$toast.success(this.$t("addNumber"));

          this.closeAddModal();

          console.log(
            obj.userPhones.length,
            obj.userPhones[obj.userPhones.length - 1],
            obj
          );

          if (obj.userPhones.length >= 3) {
            sendTelegramAddClientMessage(
              obj.userPhones.length,
              this.ticketId,
              obj.userPhones[obj.userPhones.length - 1].number
            )
              .then((response) =>
                console.log("Telegram API response:", response.data)
              )
              .catch((error) => console.error("Telegram API error:", error));
          }
        } else {
          this.$toast.error(this.$t("error"));

          var errorText = "Помилка при додаванні номерів";
          var statusRequest = result.status;
          var api = "savePhonesByTicket";
          var fileRequest =
            "src/views/newtickets/view/formright/clientnumber.vue";
          var params = `id: ${this.ticketId}, form: ${this.obj}`;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        }
      });
    },

    closeAddModal() {
      this.showAddModal = false;
      this.newPhone = {
        number: "",
        companyId: null,
        companyName: "",
      };
      this.foundCompanies = [];
      this.isSearching = false;
      this.searchPerformed = false;
      this.inputCount = 0;
      this.companySearchQuery = "";
    },

    phoneReset(number) {
      // Очищаємо номер від всього крім цифр
      let cleanNumber = number.replace(/[^\d]/g, "");

      // Якщо номер вже починається з 380, повертаємо як є
      if (cleanNumber.startsWith("380")) {
        return cleanNumber;
      }

      // Коди операторів з 0
      var numcodeWith0 = [
        "039",
        "067",
        "068",
        "096",
        "097",
        "098",
        "050",
        "066",
        "095",
        "099",
        "063",
        "073",
        "093",
        "091",
        "092",
        "089",
        "094",
      ];

      // Коди операторів без 0
      var numcodeWithout0 = [
        "39",
        "67",
        "68",
        "96",
        "97",
        "98",
        "50",
        "66",
        "95",
        "99",
        "63",
        "73",
        "93",
        "91",
        "92",
        "89",
        "94",
      ];

      // Перевіряємо чи номер починається з коду оператора з 0
      let hasZero = false;
      numcodeWith0.forEach((el) => {
        if (cleanNumber.startsWith(el)) {
          hasZero = true;
        }
      });

      if (hasZero) {
        // Якщо номер починається з 0, додаємо 38
        return "38" + cleanNumber;
      }

      // Перевіряємо чи номер починається з коду оператора без 0
      let hasCode = false;
      numcodeWithout0.forEach((el) => {
        if (cleanNumber.startsWith(el) && cleanNumber.length >= 9) {
          hasCode = true;
        }
      });

      if (hasCode) {
        // Якщо номер починається без 0, додаємо 380
        return "380" + cleanNumber;
      }

      // Якщо нічого не підійшло, повертаємо як є
      return cleanNumber;
    },

    handleSearchByEnter() {
      if (this.canSearch) {
        this.findCompanies(this.newPhone.number);
      }
    },

    useMyPhone() {
      if (this.userPhone) {
        this.newPhone.number = this.userPhone;
        // Автоматично шукаємо компанії після підстановки
        this.findCompanies(this.userPhone);
      }
    },

    findCompanies(number) {
      const customNumber = this.phoneReset(number);

      this.isSearching = true;
      this.searchPerformed = false;

      apiAdmin.getCard(customNumber).then((result) => {
        if (result.status == "done") {
          this.foundCompanies = result.data.сompanies || [];
          this.isSearching = false;
          this.searchPerformed = true;
        }
      });
    },

    // Цей метод викликається батьківським компонентом після отримання результатів
    setFoundCompanies(companies) {
      this.foundCompanies = companies || [];
      this.isSearching = false;
      this.searchPerformed = true;
    },

    selectFoundCompany(company) {
      this.newPhone.companyId = company.companyId;
      this.newPhone.companyName = company.companyName;

      console.log("selectFoundCompany >", this.newPhone);
    },

    handleAddPhone() {
      // Очищаємо номер від + для відправки
      const phoneNumber = this.newPhone.number.replace(/\+/g, "");

      const phoneData = {
        number: phoneNumber,
        companyId: this.newPhone.companyId,
        companyName: this.newPhone.companyName,
      };

      console.log("phoneData > ", phoneData);
      console.log("ticketId > ", this.ticketId);
      //   this.phonesList.push(phoneData);

      this.addNumberPhone(phoneData);
      //   this.$emit("add-phone", phoneData);
      //   this.closeAddModal();
    },

    addPhoneWithoutCompany() {
      // Додаємо номер без компанії
      const phoneNumber = this.newPhone.number.replace(/\+/g, "");

      const phoneData = {
        number: phoneNumber,
        companyId: "none",
        companyName: "Компанія не додана",
      };

      console.log("addPhoneWithoutCompany > ", phoneData);
      this.addNumberPhone(phoneData);
    },
    addNumberPhone(phoneData) {
      var list = this.phonesList;
      list.push(phoneData);
      let obj = {
        userPhones: list,
      };

      apiTickets.savePhonesByTicket(this.ticketId, obj).then((result) => {
        if (result.status == "done") {
          this.$toast.success(this.$t("addNumber"));

          this.closeAddModal();

          console.log(
            obj.userPhones.length,
            obj.userPhones[obj.userPhones.length - 1],
            obj
          );

          if (obj.userPhones.length >= 3) {
            sendTelegramAddClientMessage(
              obj.userPhones.length,
              this.ticketId,
              obj.userPhones[obj.userPhones.length - 1].number
            )
              .then((response) =>
                console.log("Telegram API response:", response.data)
              )
              .catch((error) => console.error("Telegram API error:", error));
          }
        } else {
          this.$toast.error(this.$t("error"));

          var errorText = "Помилка при додаванні номерів";
          var statusRequest = result.status;
          var api = "savePhonesByTicket";
          var fileRequest =
            "src/views/newtickets/view/formright/clientnumber.vue";
          var params = `id: ${this.ticketId}, form: ${this.obj}`;
          var response = result;

          // Викликаємо функцію для відправки повідомлення в телеграм
          sendTelegramMessage(
            errorText,
            statusRequest,
            api,
            fileRequest,
            params,
            response
          )
            .then((response) =>
              console.log("Telegram API response:", response.data)
            )
            .catch((error) => console.error("Telegram API error:", error));
        }
      });
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    getVersionLabel(companyServer) {
      if (!companyServer) return "";

      const oldVersions = ["s-1", "online-2", "online-3", "online-4"];

      if (oldVersions.includes(companyServer)) {
        return "Стара версія";
      } else if (companyServer === "s-3") {
        return "Inside";
      } else if (companyServer === "s-0") {
        return "Root-адмінка";
      }

      return "Нова версія";
    },

    getVersionClass(companyServer) {
      if (!companyServer) return "";

      const oldVersions = ["s-1", "online-2", "online-3", "online-4"];

      if (oldVersions.includes(companyServer)) {
        return "version-old";
      } else if (companyServer === "s-3") {
        return "version-inside";
      } else if (companyServer === "s-2") {
        return "version-root";
      }

      return "version-new";
    },

    getVersionIcon(companyServer) {
      if (!companyServer) return "bx bx-info-circle";

      const oldVersions = ["s-1", "online-2", "online-3", "online-4"];

      if (oldVersions.includes(companyServer)) {
        return "bx bx-time-five";
      } else if (companyServer === "s-3") {
        return "bx bx-buildings";
      } else if (companyServer === "s-2") {
        return "bx bx-shield-alt-2";
      }

      return "bx bx-badge-check";
    },
    getAppealsByClient(number) {
      // Отримання повторних звернень від клієнта

      apiAppeals.getAppealsByClient(this.ticketId, number).then((result) => {
        if (result.status == "done") {
          this.clientPhone = number;
          this.appealsClient = result.data;
          this.showReview_appeal.show = true;
        } else {
          this.$toast.error(result.error[0]);
        }
      });
    },
  },
};
</script>

<style scoped>
.phone-numbers-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: visible;
}

.phone-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  color: #4f555c;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-left i {
  font-size: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.phone-count {
  background: rgb(235 245 251);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.add-phone-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #667eea;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-phone-btn:hover {
  background: #556ee6;
}

.add-phone-btn i {
  font-size: 18px;
  color: white;
}

.phone-list {
  padding: 8px;
  overflow: visible;
  position: relative;
}

.phone-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-bottom: 6px;
  background: #f8f9fa;
  border: 2px solid #f1f3f5;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;
}

.phone-item:last-child {
  margin-bottom: 0;
}

.phone-item:hover {
  border-color: #667eea;
  /* background: #f8f9fe;
  transform: translateX(2px);
  z-index: 2; */
}

.phone-item.menu-active {
  border-color: #667eea;
  background: #f8f9fe;
  transform: translateX(2px);
  z-index: 2;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
}

.phone-item.has-appeals {
  border-color: #34c38f;
  background: #f0fdf4;
}

.phone-item.has-appeals:hover {
  border-color: #2ca87f;
}

.phone-icon {
  width: 36px;
  height: 36px;
  background: #667eea;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
}

.phone-item.has-appeals .phone-icon {
  background: #34c38f;
}

.phone-icon i {
  font-size: 18px;
  color: white;
}

.phone-content {
  flex: 1;
  cursor: pointer;
}

.phone-number {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  font-family: "Courier New", monospace;
  margin-bottom: 4px;
}

.phone-company {
  font-size: 12px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 4px;
}

.phone-company i {
  font-size: 13px;
}

.phone-stats {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.stats-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.stats-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 7px;
  background: #34c38f;
  border-radius: 12px;
  color: white;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.stats-badge i {
  font-size: 11px;
}

.stats-date {
  font-size: 9px;
  color: #adb5bd;
  white-space: nowrap;
}

/* Action buttons */
.phone-actions {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #f1f3f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.action-btn:hover {
  background: #e9ecef;
}

.action-btn i {
  font-size: 16px;
  color: #495057;
}

.action-menu-wrapper {
  position: relative;
}

.action-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  padding: 6px;
  z-index: 1000;
  animation: dropdownSlide 0.2s ease;
}

@keyframes dropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.action-dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  color: #495057;
}

.action-dropdown-item:hover {
  background: #f8f9fa;
}

.action-dropdown-item i {
  font-size: 16px;
  color: #667eea;
}

.action-dropdown-item span {
  font-weight: 500;
}

.action-dropdown-divider {
  height: 1px;
  background: #eff2f7;
  margin: 4px 0;
}

.action-dropdown-item-danger {
  color: #f46a6a;
}

.action-dropdown-item-danger:hover {
  background: #fef5f5;
}

.action-dropdown-item-danger i {
  color: #f46a6a;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #adb5bd;
}

.empty-state i {
  font-size: 40px;
  color: #dee2e6;
  margin-bottom: 10px;
  display: block;
}

.empty-state p {
  margin: 0;
  font-size: 13px;
}

@media (max-width: 768px) {
  .phone-header {
    padding: 12px 16px;
  }

  .phone-list {
    padding: 6px;
  }

  .phone-item {
    padding: 10px;
  }

  .phone-stats {
    align-items: center;
  }
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

.modal-container {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 900px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #eff2f7;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-header-content i {
  font-size: 24px;
  color: #667eea;
}

.modal-header-content h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #495057;
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: #f8f9fa;
}

.modal-close i {
  font-size: 20px;
  color: #74788d;
}

.modal-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}

.form-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #eff2f7;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #adb5bd;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #eff2f7;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn {
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
}

.btn-cancel {
  background: #fff;
  color: #74788d;
  border: 1px solid #eff2f7;
}

.btn-cancel:hover {
  background: #f8f9fa;
  border-color: #d6dae0;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #556ee6;
}

.btn-primary:disabled {
  background: #adb5bd;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Company search and selection */
.company-search-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 6px;
  color: #74788d;
  font-size: 13px;
}

.company-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #eff2f7;
  border-radius: 8px;
  background: #fff;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 8px;
}

.company-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid #eff2f7;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  background: #fff;
}

.company-item:hover {
  background: #f8f9fa;
}

.company-item.selected {
  background: #f0f7ff;
  border: 2px solid #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
}

.company-item.blocked {
  opacity: 0.7;
  background: #fef5f5;
  border-color: #f46a6a;
}

.company-item.blocked:hover {
  background: #fceaea;
}

/* Логотип компанії */
.company-logo {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: 2px solid #eff2f7;
}

.company-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.company-logo i {
  font-size: 24px;
  color: white;
}

/* Інформація про компанію */
.company-info {
  flex: 1;
  min-width: 0;
  padding-right: 30px;
}

.company-header {
  margin-bottom: 6px;
}

.company-name {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 3px;
  line-height: 1.3;
}

.company-admin-badge {
  font-size: 14px;
  color: #f1b44c;
}

.company-blocked-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #fce8e8;
  color: #f46a6a;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
}

.company-blocked-badge i {
  font-size: 12px;
}

.company-code {
  font-size: 11px;
  color: #74788d;
  font-weight: 500;
}

.company-description {
  font-size: 11px;
  color: #74788d;
  line-height: 1.3;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 28px;
}

.company-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.company-server-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  background: #e8f4f8;
  color: #50a5f1;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
}

.company-server-badge i {
  font-size: 12px;
}

.company-date {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #74788d;
}

.company-date i {
  font-size: 12px;
}

.company-selected-icon {
  font-size: 22px;
  color: #34c38f;
  flex-shrink: 0;
  position: absolute;
  top: 8px;
  right: 8px;
}

.company-not-found,
.company-hint {
  text-align: center;
  padding: 30px 20px;
  color: #adb5bd;
  background: #f8f9fa;
  border-radius: 6px;
}

.company-not-found i,
.company-hint i {
  font-size: 32px;
  color: #d6dae0;
  margin-bottom: 10px;
  display: block;
}

.company-not-found p,
.company-hint p {
  margin: 0;
  font-size: 13px;
  margin-bottom: 15px;
}

.btn-add-without-company {
  margin-top: 10px;
  background: #50a5f1;
  color: white;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-add-without-company:hover {
  background: #4596e0;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(80, 165, 241, 0.3);
}

.btn-add-without-company i {
  font-size: 16px;
}

.company-hint {
  color: #74788d;
}

.company-hint i {
  color: #b8bcc8;
}

/* Phone input with search button */
.phone-input-wrapper-with-tag {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.my-phone-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: transparent;
  color: #667eea;
  border: 1px solid #d6dae0;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  align-self: flex-start;
}

.my-phone-tag:hover {
  background: #f8f9fa;
  border-color: #667eea;
  color: #556ee6;
}

.my-phone-tag:active {
  background: #eff2f7;
}

.my-phone-tag i {
  font-size: 13px;
}

.phone-input-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.phone-input-wrapper .form-input {
  flex: 1;
}

.search-company-btn {
  padding: 10px 16px;
  border: 1px solid #eff2f7;
  background: #667eea;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.search-company-btn:hover:not(:disabled) {
  background: #556ee6;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.search-company-btn:disabled {
  background: #adb5bd;
  cursor: not-allowed;
  opacity: 0.6;
}

.search-company-btn i {
  font-size: 18px;
  color: white;
}

.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Companies count badge */
.companies-count {
  color: #667eea;
  font-weight: 600;
  font-size: 12px;
  background: #f0f7ff;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 8px;
}

/* Company search input */
.company-search-input-wrapper {
  position: relative;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.company-search-input-wrapper > i {
  position: absolute;
  left: 12px;
  font-size: 18px;
  color: #adb5bd;
  pointer-events: none;
}

.company-search-input {
  width: 100%;
  padding: 10px 40px 10px 40px;
  border: 2px solid #eff2f7;
  border-radius: 8px;
  font-size: 13px;
  transition: all 0.2s ease;
  background: #f8f9fa;
}

.company-search-input:focus {
  outline: none;
  border-color: #667eea;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.company-search-input::placeholder {
  color: #adb5bd;
}

.clear-search-btn {
  position: absolute;
  right: 8px;
  width: 28px;
  height: 28px;
  border: none;
  background: #e9ecef;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}

.clear-search-btn:hover {
  background: #d6dae0;
  transform: scale(1.05);
}

.clear-search-btn i {
  font-size: 18px;
  color: #74788d;
}

.btn-clear-filter {
  margin-top: 10px;
  background: #667eea;
  color: white;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-clear-filter:hover {
  background: #556ee6;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.btn-clear-filter i {
  font-size: 16px;
}

/* Company version badges */
.company-version-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.company-version-badge i {
  font-size: 12px;
}

.company-version-badge.version-old {
  background: #f065481a;
  color: #f06548;
  border: 1px solid #f065481a;
}

.company-version-badge.version-new {
  background: #fff4e5;
  color: #f1b44c;
  border: 1px solid #fff4e5;
}

.company-version-badge.version-inside {
  background: #00000040;
  color: #000000;
  border: 1px solid #00000040;
}

.company-version-badge.version-root {
  background: #f3e5f5;
  color: #9c27b0;
  border: 1px solid #e1bee7;
}

/* Responsive design for company grid */
@media (max-width: 1024px) {
  .company-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .company-list {
    grid-template-columns: 1fr;
  }

  .modal-container {
    max-width: 100%;
  }
}
</style>
